/* eslint-disable */
import { loadGmap } from '../../../../../general/js/loadGmap';

var map;
var defaultZoom = 8;
var geocoder;
var pinTitle = "Unipol Leeds";
var minZoomLevel = 1;
var pinList = [];
var singleItemZoom = 15;
var originMarker;


$(function () {
    if (typeof google === 'object' && typeof google.maps === 'object') {
        window.initializeMap();
        //Load Points of interest
    } else {
        loadGmap('initializeMap');
    }
});


$(document).on("click", '.city-info-link', function () {

	var affiliateCity = $(this).data('city-filter');
	loadAffiliate(affiliateCity);

});


function showSelectedCity() {

    $.get('/my-unipol/selectedcity', function (data) {

        if (data !== "") {
            loadAffiliate(data);
        }
        return data;
    });

}



function loadAffiliate(city) {
	if (city.length < 100) {

		// TODO find where showProgress() is defined
		// window.unipolSharedNamespace.showProgress();

		$.ajax({
			url: '/affiliatedatabycity/?city=' + city,
			type: "Get",
			success: function (data, status, XMLHttpRequest) {

				$('#location-name').text(data.affiliate.name);
				$('#selected-city-filter span').text(data.affiliate.name);
				$('.selected-city').text(data.affiliate.name);
				$('#location-phone').text(data.affiliate.phoneNumber);

				var mailtoLink = "<a href='mailto:" + data.affiliate.contactEmail + "'>" + data.affiliate.contactEmail + "</a>";
				$('#location-email').html(mailtoLink);

				var latlng = new google.maps.LatLng(parseFloat(data.affiliate.lat), parseFloat(data.affiliate.long));
				map.setCenter(latlng);
				originMarker.setTitle("Unipol " + data.affiliate.name);
				originMarker.setPosition(latlng);

				// TODO find where hideProgress() is defined
				// window.unipolSharedNamespace.hideProgress();

				$('#city-info-data').removeClass("d-none");

			},
			error: function (XMLHttpRequest, status, error) {
                if (error) {
                    alert('An Error occurred: ' + error);
                }

				// TODO find where hideProgress() is defined
				// window.unipolSharedNamespace.hideProgress();
			}
		});
	}

}

// Initialize the Google map
window.initializeMap = function() {
    var mapCenter = new google.maps.LatLng(53.367692, -1.574135);
    // Define Marker properties
    var pin = new google.maps.MarkerImage('/dist/images/pin-unipol-small.png',
        // This marker is 129 pixels wide by 42 pixels tall.
        new google.maps.Size(84, 91),
        // The origin for this image is 0,0.
        new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at 18,42.
        new google.maps.Point(22, 64)
    );
    geocoder = new google.maps.Geocoder();
	var mapOptions = {
		zoom: defaultZoom,
		center: mapCenter,
		mapTypeId: google.maps.MapTypeId.ROADMAP
	};
	//for contact page
    map = new google.maps.Map(document.getElementById('map-canvas-location'), mapOptions);

	originMarker = new google.maps.Marker({
		position: mapCenter,
		map: map,
		icon: pin,
		title: pinTitle
	});

    // Limit the zoom level
    google.maps.event.addListener(map, 'zoom_changed', function () {
        if (map.getZoom() < minZoomLevel) map.setZoom(minZoomLevel);
	});

    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
        if (map.getZoom() > singleItemZoom) map.setZoom(singleItemZoom);
    });

    let infowindow = new google.maps.InfoWindow({
        content: "holding..."
    });

    google.maps.event.addDomListener(window, 'resize', function () {
        map.setCenter(mapCenter);
    });

    loadPOIPins();
    showSelectedCity();

}


function loadPOIPins() {
    $.ajax({
        url: '/accommodation/affiliate/pins',
        type: "GET",
        success: function (data, status, XMLHttpRequest) {

            $.each(data, function (i, item) {
                var object = item;
                let newPOI = new Object();
                newPOI.id = object.affiliateId;
                newPOI.name = object.name;
                newPOI.lat = object.lat;
                newPOI.lng = object.long;

                if (object.Lat !== null) {
					var latlng = new google.maps.LatLng(parseFloat(newPOI.lat), parseFloat(newPOI.lng));
                    newPOI.latlng = latlng;
                    pinList.push(newPOI);
                }
            });

			//for (var i = 0; i < pinList.length; i++) {
			//	var marker = new google.maps.Marker({
			//		position: pinList[i].latlng,
			//		map: map,
			//		title: pinList[i].name
			//	});
			//}
		},
        error: function (XMLHttpRequest, status, error) {
            if (error) {
                alert('An Error occurred: ' + error);
            }
        }
	}, 1000);
}
